import Request from '../common/api/request';
import ServiceResultFactory from '../common/api/ServiceResultFactory';

const addFolloweeToNetwork = (baseApiUrl, digitalPortfolioId, followeeId, followeeType, locale) => {
  const mutation = `mutation { followFollowee(followRequest: {
                digitalPortfolioId: "${digitalPortfolioId}",
                followeeId: "${followeeId}",
                followeeType: "${followeeType}"
            })
          }`;
  return Request.graphqlRequest(baseApiUrl, mutation)
    .then((response) => ServiceResultFactory.fromSuccess(response.body))
    .catch(() => {
      throw ServiceResultFactory.error.constructLocalizedErrorMessage(locale, ['add_followee_to_network']);
    });
};

const removeFolloweeFromNetwork = (baseApiUrl, digitalPortfolioId, followeeId, locale) => {
  const mutation = `mutation { unfollowFollowee(followRequest: {
                digitalPortfolioId: "${digitalPortfolioId}",
                followeeId: "${followeeId}"
            })
          }`;
  return Request.graphqlRequest(baseApiUrl, mutation)
    .then((response) => ServiceResultFactory.fromSuccess(response.body))
    .catch(() => {
      throw ServiceResultFactory.error.constructLocalizedErrorMessage(locale, ['remove_followee_from_network']);
    });
};

const getNetworkFollowees = (baseApiUrl, digitalPortfolioId, locale) => {
  const query = `query{ networkFollowees(
                digitalPortfolioId: "${digitalPortfolioId}"
            ){ 
            followeeId, 
            followeeType 
         }
        }`;

  return Request.graphqlRequest(baseApiUrl, query)
    .then((response) => ServiceResultFactory.fromSuccess(response.body))
    .catch(() => {
      throw ServiceResultFactory.error.constructLocalizedErrorMessage(locale, ['networking_error']);
    });
};

export default {
  addFolloweeToNetwork,
  removeFolloweeFromNetwork,
  getNetworkFollowees
};
